import React from 'react';
import { ArrowPathIcon, SparklesIcon } from '@heroicons/react/24/outline';
import { useAdviceSync } from '../../context/AdviceSyncContext';

/**
 * Shared "what matters now" — same canonical focus across chat surfaces.
 */
const AuraFocusStrip = ({ className = '', compact = false }) => {
  const { focusLine, loading, refresh, lastSynced } = useAdviceSync();

  if (!focusLine && !loading) return null;

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border border-pine/25 bg-pine-tint/30 px-3 py-2.5 ${
        compact ? 'text-label' : ''
      } ${className}`}
      role="status"
    >
      <SparklesIcon className="w-4 h-4 text-pine shrink-0 mt-0.5" aria-hidden />
      <div className="flex-1 min-w-0">
        <p className="text-label text-secondary mb-0.5">Aura&apos;s focus (synced everywhere)</p>
        <p className={`text-body text-primary ${compact ? 'line-clamp-2' : ''}`}>
          {loading && !focusLine ? 'Syncing your plan…' : focusLine}
        </p>
      </div>
      <button
        type="button"
        onClick={() => refresh()}
        disabled={loading}
        className="p-1.5 text-secondary hover:text-pine shrink-0"
        title={lastSynced ? `Last synced ${new Date(lastSynced).toLocaleTimeString()}` : 'Refresh'}
        aria-label="Refresh advice sync"
      >
        <ArrowPathIcon className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
      </button>
    </div>
  );
};

export default AuraFocusStrip;
